<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório consolidado aplicação">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/imunizacao/relatorio-consolidado-aplicacao/List'

export default {
    components: { List },
}
</script>